import { OddsFormat, RoundRobinOption, OddsFormatVS, WinRiskType, VsBetType, VS_GAME_TYPE, BETSLIP_TABS } from "../../../../common/Foundation";
import BetslipCommon from "../../../../common/BetslipCommon";
import Constants from "../../../../common/Constants";
import $ from 'jquery'
import BetslipHelper from "./BetslipHelper";

export default class VSBetslipHelper {

  

  static validateVSParlayBet = (oddSelection, stake) => {
    let errors = {}
    if (!stake) {
      stake = 0
    }
    const minStake = oddSelection[0].minBet
    const maxStake = oddSelection[0].maxBet
    const convertedStake = BetslipCommon.convertStakeToNumber(stake)

    if (!convertedStake || convertedStake < minStake) {
      errors.message = Constants.INVALID_MIN_STAKE
      errors.stake = minStake
    } else if (convertedStake > maxStake) {
      errors.message = Constants.INVALID_MAX_STAKE
      errors.stake = maxStake
    }
    return errors
  }

  static oddsSelectionInfo = (oddSelections, selectionIds, eventIds, data, selectedBetslipTab) => {
    Object.keys(data).forEach(id => {
      const index = selectionIds.indexOf(id);
      const isNewSelection = index === -1;
      if (data[id].betStatus === Constants.VS_ERROR.VS_BET_STOPPED_STATUS) {
        data[id].errorCode = Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE;
      } else {
        if (selectedBetslipTab === BETSLIP_TABS.PARLAY) {
          data[id].invalidTicket = false
          data[id].errorCode = ''
          if (isNewSelection && eventIds.length > 1 &&  eventIds.indexOf(data[id].eventId.toString()) > -1) {
            data[id].invalidTicket = true
            data[id].errorCode = Constants.VS_ERROR.VS_PARLAY_INVALID_MESSAGE
          }
        }
      }

      if (isNewSelection) {
        eventIds.push(data[id].eventId.toString());
        selectionIds.push(id);
        oddSelections.push(data[id]);
      }  else {
        Object.assign(oddSelections[index], data[id])
      }
    })
  }

  static refreshOdds = (oddSelections = {}, selectionIds, eventIds, vsOddsFormat, data, selectedBetslipTab) => {
    Object.keys(data).forEach(id => {
      const index = selectionIds.indexOf(id);
      if (data[id].betStatus === Constants.VS_ERROR.VS_BET_STOPPED_STATUS) {
        data[id].errorCode = Constants.VS_ERROR.VS_BET_STOPPED_ERROR_CODE;
      } else {
        if (index > -1) {
          data[id].invalidTicket = false
          data[id].errorCode = ''
          if (selectedBetslipTab === BETSLIP_TABS.PARLAY) {
            if (eventIds.indexOf(data[id].eventId.toString()) > -1) {
              data[id].invalidTicket = true
              data[id].errorCode = Constants.VS_ERROR.VS_PARLAY_INVALID_MESSAGE
            }
          }
        }
      }
      Object.assign(oddSelections[index], data[id])
    })
  } 

  static generateRRO = (oddSelections, vsOddsFormat) => {
    if (oddSelections.length < 1) {
      return []
    }
    const lst = []
    const numberLegs = oddSelections.length
    const newArr = [].init(numberLegs)
    const arr = VSBetslipHelper.calculateRRO(newArr, 1)

    const combinations = arr.filter(a => { return a.length === 1})

    const iCountMapping = {
      1: 'PARLAY',
      2: 'TWO_LEGS',
      3: 'THREE_LEGS',
      4: 'FOUR_LEGS',
      5: 'FIVE_LEGS',
      6: 'SIX_LEGS',
      7: 'SEVEN_LEGS',
      8: 'EIGHT_LEGS'
    }
    
    var defaultRRO = {
        'odds': BetslipCommon.formatOddsValue(VSBetslipHelper.calculateTotalParlayOdds(oddSelections, vsOddsFormat), OddsFormat[vsOddsFormat]), 
        'rroCombinations': combinations,
        'possibleWagers': 1,
        'roundRobinOption' : RoundRobinOption.PARLAY,
        'rroLegs': numberLegs
    }

    lst.push(defaultRRO)
    if(numberLegs > 1 && numberLegs < 9) {               
        const iLength = newArr.length;
        for(let iCount = iLength - 1; iCount > 1; iCount --) {
            const combinations = arr.filter(a => {
              return a.length === iCount
            })
            const rroObj = {
                'rroCombinations':  combinations,
                'roundRobinOption': RoundRobinOption[iCountMapping[iCount]],
                'possibleWagers': combinations.length,
                'rroLegs': iCount
            };
            lst.push(rroObj);
        }
    } 
    return lst;            
  }

  static calculateRRO = (arr, noEle) => {            
    const fn = (n, src, got, all) => {
        if (n === 0) {
            if (got.length > 0) {
                all[all.length] = got
            }
            return
        }
        for (let j = 0; j < src.length; j++) {
            fn(n - 1, src.slice(j + 1), got.concat([src[j]]), all)
        }
        return
    };
    const all = []
    for (let i = noEle; i < arr.length; i++) {
        fn(i, arr, [], all)
    }
    return all
}


static calculateTotalParlayOdds = (selections, vsOddsFormat) => {
  let totalOdds = 1
  selections.forEach(selection => {
    if (selection.isMoneyLine && vsOddsFormat !== OddsFormatVS.American && vsOddsFormat !== OddsFormatVS.Decimal) {
      totalOdds *= parseFloat(selection.odds)
    } else {
      if(parseFloat(selection.unroundedDecimalOdds) > 0){
        totalOdds *= parseFloat(selection.unroundedDecimalOdds);
      } else {
        totalOdds *= BetslipCommon.convertToDecimalOdds(OddsFormat[vsOddsFormat], selection.odds)
      }
    }
  })
  const parlayOdds = BetslipCommon.convertOddsByOddsFormat(totalOdds, OddsFormat.EU, OddsFormat[vsOddsFormat]);
  return vsOddsFormat === OddsFormatVS.American
    ? Math.floor(parseFloat(parlayOdds.replaceAll(Constants.THOUSANDS_SEPARATOR, '')))
    : parlayOdds;
}

static getParlayMinBetMaxBet = (selections) => {
  const bet = {
    minBet: 0,
    maxBet: 0
  }
  if (selections.length === 0) {
    return bet
  }
  bet.minBet = selections[0].minBet
  bet.maxBet = selections[0].maxBet
  return bet
  
}

static isDisableVSBets = (oddSelections) => {
  const errors = oddSelections.filter(selection => {
    return VSBetslipHelper.isInvalidVSBet(selection)
  })
  return errors.length > 0
}

static isInvalidVSBet = (selection) => {
  const isBetStopped = selection.betStatus === Constants.VS_ERROR.VS_BET_STOPPED_STATUS || selection.placeBetStatus === Constants.VS_ERROR.INVALID
  const isBetInvalid = selection.invalidTicket === true
  return isBetStopped || isBetInvalid
}

static isAllVSBetSuccessfully = (oddsSelection) => {
  if (oddsSelection.length === 0) {
    return false
  }
  const filter = oddsSelection.filter(sel => {
    return sel.placeBetStatus === Constants.VS_ERROR.VS_PLACE_BET_SUCCESS_STATUS
  })
  return oddsSelection.length === filter.length
}

static calculateVSWinRiskInfo = (stakeStr, oddSelections, roundRobinOptions, selectedRROs, vsOddsFormat) => {
  const winRiskInfo = {
    totalStake: 0,
    toWin: 0
  }
  const stake = Number(`${stakeStr}`.replaceAll(',', ''))
  if (!stake || stake === 0) {
    return winRiskInfo
  }
  if (roundRobinOptions.length > 0) {
    roundRobinOptions.forEach(rro => {
      if (rro.roundRobinOption === RoundRobinOption.PARLAY) {
        winRiskInfo.toWin +=  BetslipCommon.calculateToWinFromRisk(stake, rro.odds, OddsFormat[vsOddsFormat])
        winRiskInfo.totalStake += stake * rro.possibleWagers
      } else {
        if (selectedRROs.indexOf(rro.roundRobinOption) > -1) {
          rro.rroCombinations.forEach(c => {
            let singleLeg = 1
            c.forEach((rro) => {
              if (oddSelections[rro].isMoneyLine && vsOddsFormat !== OddsFormatVS.American && vsOddsFormat !== OddsFormatVS.Decimal) {
                singleLeg *= oddSelections[rro].odds
              } else {
                if(parseFloat(oddSelections[rro].unroundedDecimalOdds) > 0){
                  singleLeg *= parseFloat(oddSelections[rro].unroundedDecimalOdds);
                } else {
                  singleLeg *= BetslipCommon.convertToDecimalOdds(OddsFormat[vsOddsFormat], oddSelections[rro].odds)
                }
              }
            })
            const odds = BetslipCommon.convertOddsByOddsFormat(singleLeg, OddsFormat.EU, OddsFormat[vsOddsFormat])
            winRiskInfo.toWin += BetslipCommon.calculateToWinFromRisk(stake, BetslipCommon.formatOddsValue(odds, OddsFormat[vsOddsFormat]), OddsFormat[vsOddsFormat])
          })
          winRiskInfo.totalStake += stake * rro.possibleWagers
        }
      }
    })
  }
  return winRiskInfo
}

static validateVSParlayBet = (oddSelection, stake) => {
  let errors = {}
  if (!stake) {
    stake = 0
  }
  const minStake = oddSelection[0].minBet
  const maxStake = oddSelection[0].maxBet
  const convertedStake = BetslipCommon.convertStakeToNumber(stake)

  if (!convertedStake || convertedStake < minStake) {
    errors.message = Constants.INVALID_MIN_STAKE
    errors.stake = minStake
  } else if (convertedStake > maxStake) {
    errors.message = Constants.INVALID_MAX_STAKE
    errors.stake = maxStake
  }
  return errors
}

static sendMsgToVs = (msg, content) => {
  const result = {
    msg: msg,
    content: content
  }
  const __vsIframe = $("#vs_iframe");
    if (__vsIframe.length > 0) {
      const vsUrl = __vsIframe.attr('src');
      const $content = __vsIframe[0].contentWindow;
      $content.postMessage(JSON.stringify(result), vsUrl);
    }
  }

  static getVSDefaultWinRiskOption = (vsOddsFormat, odds) => {
    let winRiskOption = ''
    if (OddsFormat[vsOddsFormat] === OddsFormat.AM || OddsFormat[vsOddsFormat] === OddsFormat.EU) {
      // default winRiskOptions is Risk for AM odds and EU odds
      winRiskOption = WinRiskType.RISK
    } else {
      winRiskOption = BetslipHelper.getWinRiskOptionByOdds(odds)
    }
    return winRiskOption
  }

  static initMinMaxBet = (minMaxBets, selections, vsOddsFormat, isChangeOddsFormat) => {
    if (selections.length > 0) {
      const newMinMaxBets = {}
      selections.forEach(selection => {
        let winRiskOption = ''
        if (isChangeOddsFormat || (minMaxBets && !minMaxBets[selection.selectionId])) {
          winRiskOption = VSBetslipHelper.getVSDefaultWinRiskOption(vsOddsFormat, selection.odds)
        } else {
          winRiskOption = minMaxBets[selection.selectionId].winRiskOption
        }
        newMinMaxBets[selection.selectionId] = {
          selectionId: selection.selectionId,
          odds: selection.odds,
          winRiskOption: winRiskOption,
          minStakeRisk: selection.minStakeRisk,
          minStakeWin: selection.minStakeWin,
          minStakeBase: selection.minStakeBase,
          maxStakeRisk: selection.maxStakeRisk,
          maxStakeWin: selection.maxStakeWin,
          maxStakeBase: selection.maxStakeBase,
        }
      })
      return newMinMaxBets
    }
  }

  static calculateNumberOfParlayBets = (roundRobinOptions, selectedRROs) => {
    let totalBets = 0
    if (roundRobinOptions.length > 0) {
      roundRobinOptions.forEach(rro => {
        if (selectedRROs.indexOf(rro.roundRobinOption) > -1) {
          totalBets += rro.possibleWagers
        }
      })
    }
    return totalBets
  }

  static covertVSIconToIcomon = (vsIconName) => {
    let icon = ''
    switch (vsIconName) {
      case 'sp29':
        icon = 'icon-soccer'
        break
      case 'sp4':
        icon = 'icon-basketball'
        break
      case 'sp33':
        icon = 'icon-tennis'
        break
      case 'sp20':
        icon = 'icon-horse-racing'
        break
      case 'sp59':
        icon = 'icon-virtual-dog'
        break
      default:
        break
    }
    return icon
  }

  static getSelectionName = (translate, selectionName, gameType, oddsType, sepecialOddsTitle, specialOdds) => {
    let selection = selectionName
    if (selection === '1st') {
      selection = translate('Q1')
    } else if (selection === '2nd') {
      selection = translate('Q2')
    } else if (selection === '3rd') {
      selection = translate('Q3')
    } else if (selection === '4th') {
      selection = translate('Q4')
    }
    if (gameType === VS_GAME_TYPE.MATCH || gameType === VS_GAME_TYPE.OUTRIGHT) {
      if (specialOdds !== '' && oddsType !== VsBetType.FT3W) {
        if (sepecialOddsTitle) {
          selection.concat(sepecialOddsTitle)
        }
        selection.concat(specialOdds)
      }
    }
    return selection
  }

  static getBetExtraInfo = (translate, oddsType, subTypeId, betType) => {
    const betTypeKey = oddsType + '_' +subTypeId
    if (translate('virtualsports:'+ betTypeKey) !== betTypeKey) {
      return translate('virtualsports:'+ betTypeKey)
    } else {
      return translate(betType)
    }
  }

  static getOddTypeBySkin = (translate, skinName, btId, subTypeId, vsOddsFormat) => {
    const isShowOddTypeBySkin = Constants.VS_ODD_TYPE_BY_SKINS.indexOf(skinName) > -1
    if (isShowOddTypeBySkin) {
      if ((btId === VsBetType.ITEM3W || btId === VsBetType.FT3W || (btId === VsBetType.FT2W && subTypeId === Constants.SPORTNAME_SUB_TYPE_MATCH_WINNER))
        && vsOddsFormat !== OddsFormatVS.American) {
        return translate('mybets', OddsFormat.stringOf(OddsFormat.Decimal))
      } else {
        return translate('mybets',OddsFormat.stringOf(vsOddsFormat.oddsFormat))
      }
    }
  }

  static getTeam = (gameType, homeTeam, awayTeam, eventName, headToHead, headToHeadHome, headToHeadAway, leagueName) => {
    let team1 = '', team2 = ''
    if (gameType === VS_GAME_TYPE.MATCH) {
      team1 = homeTeam
      team2 = awayTeam
    } else if (gameType === VS_GAME_TYPE.OUTRIGHT) {
      team1 = eventName
      if (headToHead !== null) {
        team1 = headToHeadHome
        team2 = headToHeadAway
      }
    } else {
      team1 = leagueName
    }
    return {
      team1: team1,
      team2: team2
    }
  }

  static getParlayTeam = (homeTeam, awayTeam) => {
    const isAvailableHomeTeam = homeTeam !== '' && homeTeam !== undefined
    return {
      team1: isAvailableHomeTeam ? homeTeam : '',
      team2: awayTeam
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/CompactView/LeftSideBarComponent/BetslipComponent/VSBetslipHelper.js